import React from 'react';
import format from 'date-fns/format';
import _ from 'lodash';
import info from '~/assets/images/info.png';
import tickets from '~/assets/images/tickets.png';
import tv from '~/assets/images/tv.png';
import './Schedule.css';

const Schedule = ({ awayTeam, homeTeam, schedule, ticket, stream, link, siteName, live, scores }) => (
	<div className={`schedule-wrapper ${siteName === homeTeam.title && 'site-border-color'}`}>
		<div className='schedule-team'>
			<div className='logos-wrapper'>
				<div className='schedule-logos'>
				{[awayTeam, homeTeam].map((team, i) => (
					<span className={'team-logo'} key={i}>
						<img src={_.get(team, 'imageGist._1x1', '')} alt='team logo'/>
					</span>
				))}
				</div>
				<div className='schedule-names'>
					<div style={{ padding: scores ? '.3em 0' : '' }}>
						<span className='away'>{awayTeam.shortName}</span>
						{ scores !== undefined ? <span className='score'>{scores[0]}</span> : null }
					</div>
					{ !scores && <span className='at'>AT</span> }
					<div>
						<span className='home'>{homeTeam.shortName}</span>
						{ scores !== undefined ? <span className='score'>{scores[1]}</span> : null }
					</div>
				</div>
			</div>
		</div>
			<div className={`info ${live && 'live'}`}>
				<div className='links'>
					<a style={{ backgroundImage: `url(${info})` }} href={link} className='additional-info'></a>
					<a style={{ backgroundImage: `url(${tickets})` }} href={ticket} className='tickets'></a>
					{ stream && <a style={{ backgroundImage: `url(${tv})` }} href={stream} className='live-stream'></a> }
				</div>
				<div className='time'>
				{ !live ?
					<div>
						<span>{format((schedule.gameTime * 1000), 'MM/DD')}</span>
						<span>{format((schedule.gameTime * 1000), 'hh:mm A')} {schedule.gameTimeZone}</span>
					</div> : <span className='live-icon'>Live</span> }
					</div>
			</div>
	</div>
)

export default Schedule;